import { ViewTableUtils, type ViewTableColumnsLayoutType } from 'app/main/components/page-layouts';

import buttons from './InvoicesButtons';

const getInvoicesTableColumns: ViewTableColumnsLayoutType = ({ settings, t, updateRefresh }) => [
	{
		field: 'invc_title',
		headerName: t('DETAILS_INVOICES_FIELD_TITLE'),
		minWidth: 120,
		renderCell: ViewTableUtils.renderCellWithTooltip,
		hideable: false
	},
	{
		field: 'invc_d_issue',
		headerName: t('DETAILS_INVOICES_FIELD_DATE_ISSUE'),
		minWidth: 120,
		renderCell: ViewTableUtils.renderDate,
		hideable: false
	},
	{
		field: 'comp_title',
		headerName: t('DETAILS_INVOICES_FIELD_COMPANY'),
		minWidth: 200,
		flex: 1,
		renderCell: ({ value, row }) =>
			ViewTableUtils.renderCellWithTooltip({ value, to: { module: 'companies', uid: row.invc_comp_uid } }),
		hideable: false
	},
	{
		field: 'invc_internalnumber',
		headerName: t('DETAILS_INVOICES_FIELD_INTERNALNUMBER'),
		minWidth: 120,
		renderCell: ViewTableUtils.renderCellWithTooltip,
		hideable: false
	},
	{
		field: 'inst_title',
		headerName: t('DETAILS_INVOICES_FIELD_STATUS'),
		minWidth: 150,
		renderCell: ({ value, row }) => ViewTableUtils.renderSquareChip({ value, backgroundColor: row.inst_color })
	},
	{
		field: 'inty_title',
		headerName: t('DETAILS_INVOICES_FIELD_TYPE'),
		minWidth: 150,
		renderCell: ({ value, row }) => ViewTableUtils.renderSquareChip({ value, backgroundColor: row.inty_color })
	},
	// {
	// 	field: 'invc_d_expiration',
	// 	headerName: t('DETAILS_INVOICES_FIELD_DATE_EXPIRATION'),
	// 	minWidth: 120,
	// 	renderCell: ViewTableUtils.renderDate
	// },
	// {
	// 	field: 'invc_d_payment',
	// 	headerName: t('DETAILS_INVOICES_FIELD_DATE_PAYMENT'),
	// 	minWidth: 120,
	// 	renderCell: ViewTableUtils.renderDate
	// },
	{
		field: 'invc_amount_residual',
		type: 'number',
		headerName: t('DETAILS_INVOICES_FIELD_AMOUNT_RESIDUAL'),
		minWidth: 150,
		cellClassName: ({ row }) =>
			row.inty_group === 'expenses' ? 'font-semibold text-red-600' : 'font-semibold text-green-700',
		renderCell: ViewTableUtils.renderCurrency
	},
	{
		field: 'invc_amount_final_tax_excl',
		type: 'number',
		headerName: t('DETAILS_INVOICES_FIELD_AMOUNT_FINAL_TAX_EXCL'),
		minWidth: 150,
		cellClassName: ({ row }) =>
			row.inty_group === 'expenses' ? 'font-semibold text-red-600' : 'font-semibold text-green-700',
		renderCell: ViewTableUtils.renderCurrency,
		hideable: false
	},
	{
		field: 'invc_amount_final_tax_incl',
		type: 'number',
		headerName: t('DETAILS_INVOICES_FIELD_AMOUNT_FINAL_TAX_INCL'),
		minWidth: 150,
		cellClassName: ({ row }) =>
			row.inty_group === 'expenses' ? 'font-semibold text-red-600' : 'font-semibold text-green-700',
		renderCell: ViewTableUtils.renderCurrency
	},
	{
		type: 'actions',
		field: 'actions',
		width: 40,
		renderCell: ({ row }) =>
			ViewTableUtils.renderMenu({
				items: buttons.view?.itemButtons || [],
				buttonProps: { settings, model: row, updateRefresh }
			}),
		sortable: false
	}
];

export default getInvoicesTableColumns;
